// Product slider for the Shop the Lineup section. On a PDP color change
// (product:ajax-rendered) it re-renders its own section for the new product
// and swaps itself out, so the slider is rebuilt for the new markup.
class ShopTheLineup extends HTMLElement {
  connectedCallback() {
    this.abortController = null;
    this.handleAjaxRendered = this.handleAjaxRendered.bind(this);

    document.addEventListener("product:ajax-rendered", this.handleAjaxRendered);

    this.initializeSwiper();
  }

  disconnectedCallback() {
    document.removeEventListener("product:ajax-rendered", this.handleAjaxRendered);

    this.abortController?.abort();
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  initializeSwiper() {
    const container = this.querySelector("[data-shop-the-lineup-swiper]");

    if (!container) {
      return;
    }

    window.loadSwiper.then(({ Swiper, Navigation }) => {
      if (!this.isConnected) {
        return;
      }

      const prevEl = this.querySelector("[data-shop-the-lineup-previous]");
      const nextEl = this.querySelector("[data-shop-the-lineup-next]");

      this.swiper = new Swiper(container, {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 16,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      });
    });
  }

  async handleAjaxRendered(event) {
    const sectionId = this.dataset.sectionId;
    const destinationUrl = event.detail?.url;

    if (!sectionId || !destinationUrl) {
      return;
    }

    this.abortController?.abort();
    this.abortController = new AbortController();

    const requestUrl = new URL(destinationUrl, window.location.origin);

    requestUrl.searchParams.set("section_id", sectionId);

    try {
      const response = await fetch(requestUrl.href, {
        headers: { Accept: "text/html" },
        signal: this.abortController.signal,
      });

      if (!response.ok) {
        throw new Error(`Shop the Lineup request failed with ${response.status}`);
      }

      const parsedDocument = new DOMParser().parseFromString(await response.text(), "text/html");
      const newElement = parsedDocument.querySelector(`shop-the-lineup[data-section-id="${CSS.escape(sectionId)}"]`);

      if (newElement) {
        this.replaceWith(newElement);
        window.initializeProductCardInteractions?.(newElement);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("[Shop the Lineup] Refresh failed:", error);
      }
    }
  }
}

if (!customElements.get("shop-the-lineup")) {
  customElements.define("shop-the-lineup", ShopTheLineup);
}
